import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { routes } from './app.routes';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';

import { provideLottieOptions } from 'ngx-lottie';

import { toObservable } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { ForexService } from './services/forex';
import { SnowplowService } from './services/snowplow';
import { AbstractDiffusionSessionService, DiffusionSessionService } from './services/diffusion';
import { AuthBridgeService } from './services/auth-bridge';
import { FEATURE_FLAG_USER_CONTEXT } from './services/feature-flags';
import { provideUnleashClient } from './providers/unleash';
import { environment } from '../environments/environment';

registerLocaleData(localeDe);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'de-DE' },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideLottieOptions({ player: () => import('lottie-web') }),

    provideAppInitializer(() => {
      const sp = inject(SnowplowService);
      sp.init();
    }),
    provideAppInitializer(() => {
      inject(ForexService).init();
    }),
    provideNgxSkeletonLoader({
      theme: {
        extendsFromRoot: true,
        height: '19px',
        background: '#abb5bf',
      },
    }),
    { provide: AbstractDiffusionSessionService, useExisting: DiffusionSessionService },
    {
      provide: FEATURE_FLAG_USER_CONTEXT,
      useFactory: (authBridge: AuthBridgeService) => ({
        isLoggedIn$: toObservable(authBridge.username).pipe(map((u) => u !== null)),
        getUserId: () => authBridge.username() ?? undefined,
      }),
      deps: [AuthBridgeService],
    },
    provideUnleashClient({
      url: environment.unleash.url,
      clientKey: environment.unleash.accessToken,
      appName: environment.unleash.appName,
      refreshInterval: environment.unleash.refreshInterval,
    }),
  ],
};
